// ** React Imports
import { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';

// ** Redux Imports
import { Provider } from 'react-redux';

// ** Intl, CASL & ThemeColors Context
import { ToastContainer } from 'react-toastify';
import { ThemeContext } from './utility/context/ThemeColors';

// ** i18n
import './configs/i18n';

// ** Spinner (Splash Screen)
// import Spinner from './@core/components/spinner/Fallback-spinner';

// ** Ripple Button
// import './@core/components/ripple-button';

// ** PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-jsx.min';

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css';

// ** React Toastify
// import '@styles/react/libs/toastify/toastify.scss';

// ** Core styles
// import './@core/assets/fonts/feather/iconfont.css';
import './assets/scss/core.scss';
import './assets/scss/style.scss';

// ** Service Worker
import * as serviceWorker from './serviceWorker';

import configureStore, { history } from './common/store';
import Loader from './common/components/modals/Loader/Loader';

import { ConnectedRouter } from 'connected-react-router';

// ** Lazy load app
const LazyApp = lazy(() => import('./App'));
const store = configureStore({});

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Suspense fallback={<Loader />}>
          <ThemeContext>
            <LazyApp />
            <ToastContainer newestOnTop />
          </ThemeContext>
      </Suspense>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about services workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
